import emailValidation from "@/lib/prismicio/prismic-email-validation.json"
import { PrismicEmailValidationJson } from "@jog/shared"

export const useEmailValidation = () => emailValidation as PrismicEmailValidationJson
